<template>
  <div/>
</template>

<script>
export default {
  props: {
    id: Number,
    type: String,
    companyId: Number
  },
  mounted() {
    const id = this.id;

    const notifId = this.$store.state.notifications.map(notification => {
      if (
        this.type == "task" &&
        notification.object_id == id &&
        (notification.type == CONST.notifications.status.taskCreated ||
          notification.type == CONST.notifications.status.commentCreated ||
          notification.type == CONST.notifications.status.taskCanceled ||
          notification.type == CONST.notifications.status.taskClosed ||
          notification.type == CONST.notifications.status.taskStatusChanged)
      )
        return notification.id;

      if (
        this.type == "documentsDue" &&
        notification.company_id == this.companyId &&
        notification.type == CONST.notifications.status.listDocsUpdated
      )
        return notification.id;
    });

    _.compact(notifId).forEach(id => {
      axios
        .post("/notifications/" + id + "/read")
        .then(() => {
          const newNotifications = this.$store.state.notifications.filter(
            notify => notify.id !== id
          );
          this.$store.commit("setNotifications", newNotifications);
        })
        .catch(() => {
          iziToast.error({
            title: "Ошибка",
            message: "API недоступен",
            backgroundColor: "#ff6736",
            position: "topRight",
            theme: "dark",
            timeout: false,
            icon: "material-icons",
            iconText: "error"
          });
        });
    });
  }
};
</script>